import React, { PropTypes, PureComponent } from 'react';
import update from 'immutability-helper';

import apiService from '../../state/services/api';

import ReviewList from '../../components/ReviewList';

/**
 * Review list container.
 * Wraps the review list containerpresentational component with Redux state.
 * Dispatches actions to fetch data and control pagination.
 */
class ReviewListContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      resultsPerPage: 3,
      reviews: null,
      page: 1,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { eventId } = this.props;
    const { resultsPerPage, page } = this.state;
    apiService.fetchReviews(eventId, { resultsPerPage, page })
      .then((response) => {
        this.setState({
          fetching: false,
          firstPage: page === 1,
          lastPage: response.total <= (page * resultsPerPage),
          reviews: response.results,
        });
      })
      .catch(() => {
        this.setState({
          fetching: false,
        });
      });
  }

  handleNext = () => {
    this.setState(state => update(state, {
      page: { $set: state.page + 1 },
    }), this.fetchData);
  }

  handlePrevious = () => {
    this.setState(state => update(state, {
      page: { $set: state.page - 1 },
    }), this.fetchData);
  }

  render() {
    return (
      <ReviewList
        onNext={this.handleNext}
        onPrevious={this.handlePrevious}
        {...this.props}
        {...this.state}
      />
    );
  }
}

ReviewListContainer.propTypes = {
  /**
   * Numberic event ID to fetch reviews for.
   */
  eventId: PropTypes.number.isRequired,
};

export default ReviewListContainer;



// WEBPACK FOOTER //
// ./app/src/containers/ReviewList/index.jsx